import { render } from "./LegCheck.vue?vue&type=template&id=1c004b3a&scoped=true"
import script from "./LegCheck.vue?vue&type=script&lang=js"
export * from "./LegCheck.vue?vue&type=script&lang=js"

import "./LegCheck.vue?vue&type=style&index=0&id=1c004b3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c004b3a"]])

export default __exports__